"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var Popover_1 = __importDefault(require("@mui/material/Popover"));
var MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
var InputBase_1 = __importDefault(require("@mui/material/InputBase"));
var react_1 = __importStar(require("react"));
var countryData_1 = require("../../utils/countryData");
var FlagIcon_1 = __importDefault(require("./FlagIcon"));
// Memoized country item component for better performance
var CountryItem = react_1.default.memo(function (_a) {
    var country = _a.country, index = _a.index, isSelected = _a.isSelected, onSelect = _a.onSelect, onMouseEnter = _a.onMouseEnter;
    return ((0, jsx_runtime_1.jsxs)(MenuItem_1.default, { id: "country-option-".concat(index), selected: isSelected, onClick: function () { return onSelect(country); }, onMouseEnter: function () { return onMouseEnter(index); }, role: "option", "aria-selected": isSelected, "aria-label": "".concat(country.name, ", ").concat(country.dialCode), sx: {
            padding: '8px 16px',
            minHeight: '48px',
            transition: 'background-color 0.2s ease',
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            '&.Mui-selected': {
                backgroundColor: 'rgba(0, 0, 0, 0.08)',
            },
            '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.04)',
            },
        }, children: [(0, jsx_runtime_1.jsx)(FlagIcon_1.default, { countryCode: country.code, style: { marginRight: '8px' } }), (0, jsx_runtime_1.jsx)("span", { style: {
                    flex: 1,
                    fontSize: '14px',
                    fontFamily: 'inherit',
                }, children: country.name }), (0, jsx_runtime_1.jsx)("span", { style: {
                    opacity: 0.7,
                    fontSize: '12px',
                    fontFamily: 'inherit',
                    marginLeft: '8px',
                }, children: country.dialCode })] }, country.code));
});
CountryItem.displayName = 'CountryItem';
var CountryDropdown = function (_a) {
    var onCountryChange = _a.onCountryChange, _b = _a.enableCountrySearch, enableCountrySearch = _b === void 0 ? false : _b, anchorEl = _a.anchorEl, open = _a.open, onClose = _a.onClose, _c = _a.searchPlaceholder, searchPlaceholder = _c === void 0 ? 'Search countries...' : _c, providedCountries = _a.countries;
    var _d = (0, react_1.useState)(''), searchTerm = _d[0], setSearchTerm = _d[1];
    var _e = (0, react_1.useState)(-1), selectedIndex = _e[0], setSelectedIndex = _e[1];
    var searchInputRef = (0, react_1.useRef)(null);
    var countries = (0, react_1.useMemo)(function () { return providedCountries || (0, countryData_1.getCountryData)(); }, [providedCountries]);
    var filteredCountries = (0, react_1.useMemo)(function () {
        if (!searchTerm.trim())
            return countries;
        var term = searchTerm.toLowerCase().trim();
        return countries.filter(function (country) {
            return country.name.toLowerCase().includes(term) ||
                country.dialCode.toLowerCase().includes(term) ||
                country.code.toLowerCase().includes(term);
        });
    }, [countries, searchTerm]);
    // Reset search state when dropdown opens/closes
    (0, react_1.useEffect)(function () {
        if (open) {
            setSearchTerm('');
            setSelectedIndex(-1);
        }
    }, [open]);
    // Auto-focus search input when dropdown opens and blur when closing
    (0, react_1.useEffect)(function () {
        if (open && enableCountrySearch) {
            var timer_1 = setTimeout(function () {
                var _a;
                (_a = searchInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            }, 100);
            return function () { return clearTimeout(timer_1); };
        }
        else if (!open) {
            // When closing, ensure any focused element inside the popover is blurred
            // to prevent aria-hidden violations
            var activeElement = document.activeElement;
            if (activeElement && activeElement.closest('#country-selector-listbox')) {
                activeElement.blur();
            }
        }
        return undefined;
    }, [open, enableCountrySearch]);
    // Memoized callbacks for better performance
    var handleCountrySelect = (0, react_1.useCallback)(function (country) {
        // Blur any focused element to prevent aria-hidden violations
        var activeElement = document.activeElement;
        if (activeElement && activeElement.closest('#country-selector-listbox')) {
            activeElement.blur();
        }
        onCountryChange(country);
        onClose();
    }, [onCountryChange, onClose]);
    var handleSearchChange = (0, react_1.useCallback)(function (event) {
        var value = event.target.value;
        setSearchTerm(value);
        setSelectedIndex(-1);
    }, []);
    var handleKeyDown = (0, react_1.useCallback)(function (event) {
        switch (event.key) {
            case 'ArrowDown':
                event.preventDefault();
                setSelectedIndex(function (prev) {
                    return prev < filteredCountries.length - 1 ? prev + 1 : prev;
                });
                break;
            case 'ArrowUp':
                event.preventDefault();
                setSelectedIndex(function (prev) { return (prev > 0 ? prev - 1 : -1); });
                break;
            case 'Enter':
                event.preventDefault();
                if (selectedIndex >= 0 && selectedIndex < filteredCountries.length) {
                    var country = filteredCountries[selectedIndex];
                    handleCountrySelect(country);
                }
                break;
            case 'Escape':
                event.preventDefault();
                onClose();
                break;
        }
    }, [filteredCountries.length, selectedIndex, handleCountrySelect, onClose]);
    return ((0, jsx_runtime_1.jsxs)(Popover_1.default, { open: open, anchorEl: anchorEl, onClose: onClose, anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
        }, transformOrigin: {
            vertical: 'top',
            horizontal: 'left',
        }, disableRestoreFocus: true, disableEnforceFocus: true, slotProps: {
            paper: {
                id: 'country-selector-listbox',
                role: 'dialog',
                'aria-label': 'Select country',
                sx: {
                    maxHeight: 400,
                    width: 300,
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column',
                },
            },
        }, children: [enableCountrySearch && ((0, jsx_runtime_1.jsx)("div", { style: {
                    padding: '12px 16px',
                    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                    backgroundColor: '#ffffff',
                }, children: (0, jsx_runtime_1.jsx)(InputBase_1.default, { ref: searchInputRef, placeholder: searchPlaceholder, value: searchTerm, onChange: handleSearchChange, onKeyDown: handleKeyDown, fullWidth: true, sx: {
                        fontSize: '14px',
                        padding: '6px 8px',
                        border: '1px solid rgba(0, 0, 0, 0.23)',
                        borderRadius: '4px',
                        backgroundColor: '#ffffff',
                        '&:focus-within': {
                            borderColor: 'primary.main',
                            boxShadow: '0 0 0 2px rgba(25, 118, 210, 0.2)',
                        },
                    }, inputProps: {
                        'aria-label': 'Search countries',
                        autoComplete: 'off',
                        spellCheck: false,
                    } }) })), (0, jsx_runtime_1.jsx)("div", { style: {
                    flex: 1,
                    overflowY: 'auto',
                    backgroundColor: '#ffffff',
                }, role: "listbox", "aria-label": "Country list", "aria-activedescendant": selectedIndex >= 0 ? "country-option-".concat(selectedIndex) : undefined, children: filteredCountries.length === 0 ? ((0, jsx_runtime_1.jsx)("div", { style: {
                        padding: '16px',
                        textAlign: 'center',
                        color: 'rgba(0, 0, 0, 0.6)',
                        fontSize: '14px',
                    }, children: "No countries found" })) : (filteredCountries.map(function (country, index) { return ((0, jsx_runtime_1.jsx)(CountryItem, { country: country, index: index, isSelected: index === selectedIndex, onSelect: handleCountrySelect, onMouseEnter: setSelectedIndex }, country.code)); })) })] }));
};
exports.default = CountryDropdown;
//# sourceMappingURL=CountryDropdown.js.map